export default __webpack_public_path__ + "static/media/avax.2a5875f3.svg";